import React, { forwardRef } from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { useUploadProgress } from './useUploadProgress';
import { Progress } from '../../../../../CommonComponents/OPL/Progress/Progress';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { ProgressIcon } from '../../../../../DocumentVault/components/UploadProgress/UploadProgress.styles';
import { UploadProgressRef } from '../../../api/useUploadDocumentMutation';

export const UploadProgress = forwardRef<UploadProgressRef>((props, ref) => {
  const {
    progressLabelRef,
    progressValueRef,
    progressBarRef,
    progressIconRef,
  } = useUploadProgress({ ref });

  return (
    <Box display="flex" css="gap: 16px">
      <Box flex={1}>
        <Progress value={0} ref={progressBarRef} />

        <Box display="flex" justifyContent="space-between" mt="8">
          <Text ref={progressLabelRef} fontWeight={500} fontSize="small">
            Uploading...
          </Text>

          <Text ref={progressValueRef} fontWeight={500} fontSize="small">
            0%
          </Text>
        </Box>
      </Box>

      <Box display="flex" justifyContent="center">
        <ProgressIcon
          ref={progressIconRef}
          className="far fa-times-circle"
          fontSize="h6"
          color="neutral.500"
          tabIndex={0}
          role="button"
        />
      </Box>
    </Box>
  );
});
